export default {
  SMALL_MOBILE_BREAKPOINT: '370px',
  DESKTOP_BREAKPOINT: '768px',
  SIDEBAR_MIN_BREAKPOINT: '1160px',
  TITLE_DEFAULT: 'Checkout | John Lewis & Partners',
  TITLE_EXPIRY_WARNING: '** Session expiring **',
  ROOT: 'root',
  COUNTRIES: 'countries',
  DELIVERY_ACCESSIBILITY_INSTRUCTIONS: [{
    label: 'Additional directions',
  }, {
    label: 'Lift or stairs access',
  }, {
    label: 'Access restrictions',
  }, {
    label: 'Someone else accepting delivery',
  }, {
    label: 'I need extra time',
  }, {
    label: 'I have vision impairments',
  }, {
    label: 'I have hearing impairments',
  }, {
    label: 'Other',
  }],
  DELIVERY_INSTRUCTIONS: [{
    label: 'Additional directions',
    prefix: 'Extra directions to my address:',
  }, {
    label: 'Restricted entry',
    prefix: 'Extra directions to my address:',
  }, {
    label: 'Parking restrictions',
    prefix: 'Extra directions to my address:',
  }, {
    label: 'Property access restrictions',
    prefix: 'Access to my property is via:',
  }, {
    label: 'Access via lift/stairs',
    prefix: 'Access to my property is via:',
  }, {
    label: 'Someone accepting delivery',
    prefix: 'Access to my property is via:',
  }, {
    label: 'Other',
    prefix: 'Access to my property is via:',
  }],
  PERSIST_ROOT: 'persist:root',
  CALL_CENTRE_NUMBERS: {
    standard: '03456 049 049',
    partnership: '0330 175 9829',
  },
  BFF_TIMEOUT: 35000,
  AUTH0_TOKEN_TIMEOUT: 5,
  CHECKOUT_AUTH0_TOKEN_TIMEOUT: 5000,
};
